import { NgModule } from '@angular/core';
import { PartnerRegisterStep2Component } from '@pg-app/partner/partner-register-step2/partner-register-step2.component';
import { PartnerRegisterStep2RoutingModule } from '@pg-app/partner/partner-register-step2/partner-register-step2-routing.module';
import { RegisterStep2Module } from '@pg-app/auth/containers/register/register-step2/register-step2.module';

@NgModule({
  imports: [RegisterStep2Module, PartnerRegisterStep2RoutingModule],
  declarations: [PartnerRegisterStep2Component]
})
export class PartnerRegisterStep2Module {}
